export default __webpack_public_path__ + "static/media/mobile_banner_payment.56911ff9.jpg";